export const generals = ()=> {
    let textClipTriggers = [];
    let fadeUpTriggers = [];
    let fadeUpClipTriggers = [];
    let fadeLeftAnimation = [];
    const func = ()=> {
        textClipTriggers.forEach(trigger => trigger.kill());
        fadeUpTriggers.forEach(trigger => trigger.kill());
        fadeUpClipTriggers.forEach(trigger => trigger.kill());
        fadeLeftAnimation.forEach(trigger => trigger.kill());

        textClipTriggers = [];
        fadeUpTriggers = [];
        fadeUpClipTriggers = [];
        fadeLeftAnimation = [];

        if (document.querySelector('.text-clip-animation')) {
            gsap.utils.toArray('.text-clip-animation').forEach(item => {
                const trigger = ScrollTrigger.create({
                    trigger: item,
                    start: 'top 85%',
                    end: 'bottom 10%',
                    onEnter: () => {
                        item.classList.add('play');
                    },
                    onLeaveBack: () => {
                        item.classList.remove('play');
                    },
                });

                textClipTriggers.push(trigger);
            })
        }
        if (document.querySelector('.fade-up-animation')) {
            gsap.utils.toArray('.fade-up-animation').forEach(item => {
                const trigger = ScrollTrigger.create({
                    trigger: item,
                    start: 'top 85%',
                    end: 'bottom 10%',
                    onEnter: () => {
                        item.classList.add('play');
                    },
                    onLeaveBack: () => {
                        item.classList.remove('play');
                    },
                });

                fadeUpTriggers.push(trigger);
            })
        }
        if (document.querySelector('.fade-up-clip-animation')) {
            gsap.utils.toArray('.fade-up-clip-animation').forEach(item => {
                const trigger = ScrollTrigger.create({
                    trigger: item,
                    start: 'top 85%',
                    end: 'bottom 10%',
                    onEnter: () => {
                        item.classList.add('play');
                    },
                    onLeaveBack: () => {
                        item.classList.remove('play');
                    },
                });

                fadeUpClipTriggers.push(trigger);
            })
        }
        if (document.querySelector('.fade-left-animation')) {
            gsap.utils.toArray('.fade-left-animation').forEach(item => {
                const trigger = ScrollTrigger.create({
                    trigger: item,
                    start: 'top 85%',
                    end: 'bottom 10%',
                    onEnter: () => {
                        item.classList.add('play');
                    },
                    onLeaveBack: () => {
                        item.classList.remove('play');
                    },
                });

                fadeLeftAnimation.push(trigger);
            })
        }
    }

    func();

    window.addEventListener('resize', () => {
        func();
    });
}